export default __webpack_public_path__ + "images/graphics/tires-car.svg";